import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * French INSEE Number validator following Single Responsibility Principle
 */
export class FrValidator extends BaseValidator {
  constructor() {
    super({
      name: 'French INSEE Number',
      pattern: /^\d{13}$/,
      length: 13
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'INSEE number must be exactly 13 digits'
    );
  }

  validateChecksum(id) {
    const first12 = id.substring(0, 12);
    const checkDigits = parseInt(id.substring(12, 13));
    
    const remainder = parseInt(first12) % 97;
    const expectedChecksum = 97 - remainder;

    if (expectedChecksum !== checkDigits) {
      return ValidationResult.invalid(`Invalid INSEE checksum. Expected: ${expectedChecksum}, Got: ${checkDigits}`);
    }

    return ValidationResult.valid('Valid INSEE number');
  }
}